<template>
  <SysDialogConfimacao
    texto_confirmacao="Deseja realmente apagar esse produto combinado?"
    txt_botao="sim, apagar"
    :largura="400"
    @confirmacao="apagarProdutoCombinado"
  >
    <template #ativador="{callback}">
      <v-btn icon @click="callback">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>
  </SysDialogConfimacao>
</template>

<script setup>
import SysDialogConfimacao from "@/components/utils/crud/SysDialogConfimacao.vue";
import store from "@/store";
import * as req from "@/api/Produtos/DemandaCombinada";
import {logout} from "@/helpers";

const props = defineProps({
  id: String
});

const emit = defineEmits(['produto-combinado-apagado'])

function apagarProdutoCombinado() {
  store.dispatch('loading/addRequisicao',
    req.apagarProdutoDemandasCombinadas(props.id)
      .then(() => emit('produto-combinado-apagado', {}))
      .catch(logout)
  )
}
</script>

<style scoped>

</style>
